"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _vuex = require("vuex");
var _Page = _interopRequireDefault(require("@/ui/layout/Page"));
var _plantNursery = require("@/services/plant-nursery.service");
var _LotsList = _interopRequireDefault(require("@/flow/plantNursery/components/LotsList.vue"));
var _LotInventorySelector = _interopRequireDefault(require("@/flow/plantNursery/components/LotInventorySelector.vue"));
var _SectionRowInventories = _interopRequireDefault(require("@/flow/plantNursery/components/SectionRowInventories.vue"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _default = exports.default = {
  name: 'MoveLotPage',
  components: {
    Page: _Page.default,
    LotsList: _LotsList.default,
    LotInventorySelector: _LotInventorySelector.default,
    SectionRowInventories: _SectionRowInventories.default
  },
  data: function data() {
    return {
      selectedLot: null,
      lots: [],
      isLoadingLots: false,
      lotListSearch: '',
      form: this.createDefaultForm(),
      isSubmitting: false
    };
  },
  computed: _objectSpread(_objectSpread({}, (0, _vuex.mapGetters)({
    page: 'menuItemsPlantsNursery',
    farm: 'GET_FARM'
  })), {}, {
    senderTotal: function senderTotal() {
      if (!this.selectedLot || !Array.isArray(this.selectedLot.inventories)) return 0;
      return this.selectedLot.inventories.reduce(function (sum, inv) {
        return sum + (Number(inv.quantity) || 0);
      }, 0);
    },
    receiverTotal: function receiverTotal() {
      if (!Array.isArray(this.form.destinationInventories)) return 0;
      return this.form.destinationInventories.reduce(function (sum, inv) {
        return sum + (Number(inv.quantity) || 0);
      }, 0);
    },
    destinationRowMissing: function destinationRowMissing() {
      return Array.isArray(this.form.destinationInventories) ? this.form.destinationInventories.some(function (inv) {
        return !(inv !== null && inv !== void 0 && inv.rowId);
      }) : false;
    },
    quantityMismatch: function quantityMismatch() {
      if (!Array.isArray(this.form.destinationInventories) || this.form.destinationInventories.length === 0) {
        return false;
      }
      return this.senderTotal !== this.receiverTotal;
    }
  }),
  watch: {
    selectedLot: function selectedLot(newLot) {
      if (newLot) {
        this.resetForm();
        this.populateDestinationInventories();
      }
    }
  },
  mounted: function mounted() {
    this.loadLots();
  },
  methods: {
    handleLotsSearch: function handleLotsSearch(searchQuery) {
      this.lotListSearch = searchQuery;
      this.loadLots();
    },
    loadLots: function () {
      var _loadLots = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this$farm, filters, _yield$plantNurserySe, response, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              this.isLoadingLots = true;
              _context.p = 1;
              filters = {
                page: 1,
                limit: 200,
                farmId: (_this$farm = this.farm) === null || _this$farm === void 0 ? void 0 : _this$farm.id
              };
              if (this.lotListSearch) {
                filters.code = this.lotListSearch;
              }
              _context.n = 2;
              return _plantNursery.plantNurseryService.fetchLots(filters);
            case 2:
              _yield$plantNurserySe = _context.v;
              response = _yield$plantNurserySe.data;
              this.lots = Array.isArray(response === null || response === void 0 ? void 0 : response.data) ? response.data : [];
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              this.lots = [];
            case 4:
              _context.p = 4;
              this.isLoadingLots = false;
              return _context.f(4);
            case 5:
              return _context.a(2);
          }
        }, _callee, this, [[1, 3, 4, 5]]);
      }));
      function loadLots() {
        return _loadLots.apply(this, arguments);
      }
      return loadLots;
    }(),
    createDefaultForm: function createDefaultForm() {
      return {
        description: '',
        transferAt: new Date(),
        senderInventories: [],
        destinationInventories: []
      };
    },
    resetForm: function resetForm() {
      this.form = this.createDefaultForm();
    },
    clearSelection: function clearSelection() {
      this.selectedLot = null;
      this.resetForm();
    },
    handleCancel: function handleCancel() {
      this.resetForm();
      this.$router.push({
        name: 'plant-nursery-lots'
      });
    },
    populateDestinationInventories: function populateDestinationInventories() {
      if (!this.selectedLot || !Array.isArray(this.selectedLot.inventories)) {
        return;
      }
      this.form.destinationInventories = this.selectedLot.inventories.map(function (inv) {
        var _inv$section, _inv$row;
        return {
          sectionId: (_inv$section = inv.section) === null || _inv$section === void 0 ? void 0 : _inv$section.id,
          rowId: (_inv$row = inv.row) === null || _inv$row === void 0 ? void 0 : _inv$row.id,
          quantity: inv.quantity
        };
      }).filter(function (item) {
        return item.sectionId && item.rowId;
      });
    },
    validateForm: function validateForm() {
      var _this$selectedLot, _this$form$destinatio;
      if (!((_this$selectedLot = this.selectedLot) !== null && _this$selectedLot !== void 0 && _this$selectedLot.id)) {
        this.$buefy.toast.open({
          message: 'Nenhum lote selecionado.',
          type: 'is-danger'
        });
        return false;
      }
      if (!((_this$form$destinatio = this.form.destinationInventories) !== null && _this$form$destinatio !== void 0 && _this$form$destinatio.length)) {
        this.$buefy.toast.open({
          message: 'Adicione pelo menos um local de destino.',
          type: 'is-danger'
        });
        return false;
      }
      if (this.quantityMismatch) {
        this.$buefy.toast.open({
          message: "Quantidade de origem (".concat(this.senderTotal, ") deve ser igual \xE0 quantidade de destino (").concat(this.receiverTotal, ")."),
          type: 'is-danger'
        });
        return false;
      }
      return true;
    },
    formatDate: function formatDate(value) {
      if (!value) return null;
      var date = value instanceof Date ? value : new Date(value);
      return Number.isNaN(date.getTime()) ? null : date.toISOString();
    },
    buildPayload: function buildPayload() {
      return {
        description: (this.form.description || '').trim() || null,
        transferAt: this.formatDate(this.form.transferAt),
        destinationInventories: this.form.destinationInventories
      };
    },
    submitForm: function () {
      var _submitForm = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var payload, _error$response, _error$response$data, message, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              if (this.validateForm()) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              payload = this.buildPayload();
              this.isSubmitting = true;
              _context2.p = 2;
              _context2.n = 3;
              return _plantNursery.plantNurseryService.moveLot(this.selectedLot.id, payload);
            case 3:
              this.$buefy.toast.open({
                message: 'Locais movidos com sucesso.',
                type: 'is-success'
              });
              this.$router.push({
                name: 'plant-nursery-lots'
              });
              _context2.n = 5;
              break;
            case 4:
              _context2.p = 4;
              _t2 = _context2.v;
              message = (_t2 === null || _t2 === void 0 ? void 0 : (_error$response = _t2.response) === null || _error$response === void 0 ? void 0 : (_error$response$data = _error$response.data) === null || _error$response$data === void 0 ? void 0 : _error$response$data.message) || (_t2 === null || _t2 === void 0 ? void 0 : _t2.message) || 'Não foi possível mover os locais.';
              this.$buefy.toast.open({
                message: message,
                type: 'is-danger'
              });
            case 5:
              _context2.p = 5;
              this.isSubmitting = false;
              return _context2.f(5);
            case 6:
              return _context2.a(2);
          }
        }, _callee2, this, [[2, 4, 5, 6]]);
      }));
      function submitForm() {
        return _submitForm.apply(this, arguments);
      }
      return submitForm;
    }()
  }
};